import {
  takeEvery,
  put,
  select,
  takeLatest,
  call,
  all,
} from 'redux-saga/effects';

import {
  SET_FORM_DATA,
  SET_FORM_ID,
  SET_SUBMITTING_FORM,
  SET_FIELD_ERROR,
  SUBMIT_FORM,
  SUBMIT_FORM_SUCCESS,
  SET_SUCCESS_MESSAGE,
  SUBMIT_FORM_ERROR,
  SUBMIT_FORM_FOR_VALIDATION,
  VALIDATE_FIELD,
  SET_CURRENT_PAGE,
  PAGE_FORWARD,
  PAGE_BACK,
  SET_FORM_ENTRIES,
  SET_DEFAULT_FIELD_VALUE,
  DO_VALIDATE_FORM,
} from './types';

import {
  selectForms,
  makeSelectFormFields,
  makeSelectFormFieldErrors,
  makeSelectFormPostData,
  makeSelectFormGroup,
} from './selectors';

import { getFormSchema, postForm, getEntries } from '../utils/api-utils';
import { doValidateField } from '../utils/validate-utils';
import { getFieldType } from '../utils/transform-utils';
import { selectors } from '@zengenti/contensis-react-base/routing';

export const sagas = [
  takeEvery(SUBMIT_FORM_SUCCESS, onFormSuccess),
  takeEvery(SUBMIT_FORM_FOR_VALIDATION, doValidateForm),
  takeEvery(SUBMIT_FORM, onSubmitForm),
  takeEvery(SET_FORM_ID, doFetchForm),
  // takeLatest(VALIDATE_FIELD, onValidateField),
  takeEvery(PAGE_FORWARD, doTogglePage),
  takeEvery(PAGE_BACK, doTogglePage),
  takeEvery(SET_FORM_DATA, getEntryPickerData),
  takeLatest(SET_FORM_DATA, setDefaultValueFields),
];

function* doValidateForm(action) {
  const { formId } = action;
  yield onValidateAllFields(formId);
  yield put({
    type: SUBMIT_FORM,
    formId,
  });
}
// function* onValidateField(action) {
//   const { formId, id, value } = action;
//   if (value?.length >= 1) yield call(onValidateSingleField, formId, id, value);
// }

function* onValidateGroupFields(formId, groupId) {


  const state = yield select();

  const selectFormFieldErrors = makeSelectFormFieldErrors(formId)
  const existingErrors = selectFormFieldErrors(state) || [];
  const existingErrorsFiltered = existingErrors?.filter(ee => ee?.groupId !== groupId) || [];
  
  const selectPostData = makeSelectFormPostData(formId);
  const postData = selectPostData(state)
  const selectFormFields = makeSelectFormFields(formId);
  const fields = selectFormFields(state);

  const groupFields = fields.filter(f => f.groupId == groupId);

  let errors = [...existingErrorsFiltered];

  groupFields.forEach(field => {
    let value = '';
    if (postData[field.id]) value = postData[field.id];
    const error = doValidateField(field, value);
    if (error) errors.push(error);
  });
  yield put({ type: SET_FIELD_ERROR, formId: formId, value: errors });
  return errors;
}

function* onValidateAllFields(formId) {
  const state = yield select();
  const selectPostData = makeSelectFormPostData(formId);
  const postData = selectPostData(state)
  const selectFormFields = makeSelectFormFields(formId);
  const fields = selectFormFields(state);

  const errors = [];
  fields.forEach(field => {
    let value = '';
    if (postData[field.id]) value = postData[field.id];
    const error = doValidateField(field, value);
    if (error) errors.push(error);
  });
  yield put({ type: SET_FIELD_ERROR, formId: formId, value: errors });
}

// function* onValidateSingleField(formId, fieldId, value) {
//   const state = yield select();
//   const selectFormFields = makeSelectFormFields(formId);
//   const fields = selectFormFields(state);

//   const selectFormFieldErrors = makeSelectFormFieldErrors(formId)
//   const errors = selectFormFieldErrors(state);

//   const fieldData = fields.find(f => f.id == fieldId);

//   const newErrors = [];
//   // loop through current errors to remove any of the item we currently edit
//   errors.forEach(error => {
//     // push any existing errors to new array
//     if (error.fieldId !== fieldId) newErrors.push(error);
//   });
//   const err = doValidateField(fieldData, value);
//   if (err) newErrors.push(err);
//   yield put({ type: SET_FIELD_ERROR, formId: formId, value: newErrors });
// }

function* doTogglePage(action) {
  const { formId, pageIndex } = action;
  const state = yield select();

  const selectFormGroups = makeSelectFormGroup(formId);
  const formGroups = selectFormGroups(state);
  
  if (action.type === PAGE_FORWARD) {
    const groupdId = formGroups[pageIndex - 1].id;
    const errors = yield onValidateGroupFields(formId, groupdId);
    const hasErrorsWithinGroup = errors?.filter(e => e.groupId === groupdId).length;

    if (!hasErrorsWithinGroup) {
      yield put({
        type: SET_CURRENT_PAGE,
        formId: formId,
        pageId: formGroups[pageIndex].id,
        pageCount: formGroups.length,
        pageIndex: pageIndex,
      });
    }
  } else if (action.type === PAGE_BACK) {
    yield put({
      type: SET_CURRENT_PAGE,
      formId: formId,
      pageId: formGroups[pageIndex].id,
      pageCount: formGroups.length,
      pageIndex: pageIndex,
    });
  }
}
function* doFetchForm(action) {
  const formId = action.formId;
  const schema = yield getFormSchema(formId);

  const groups = schema?.groups?.filter(group => (group.id !== 'private' && group.id !== 'settings'));

  if (formId && schema) {
    if (schema?.groups?.length > 0) {
      yield put({
        type: SET_CURRENT_PAGE,
        formId: formId,
        pageId: groups[0].id,
        pageIndex: 0,
        pageCount: groups.length,
      });
    }

    const submitButtonText = schema.fields.find(f => f.id === 'submitButtonText');
    const fields = schema?.fields.map(field => { 
      return {
        ...field,
        type: getFieldType(field)
      }
    })
    
    yield put({
      type: SET_FORM_DATA,
      formId: formId,
      fields,
      groups: groups,
      defaultLanguage: schema.defaultLanguage,
      settings: {
        submitButtonText: submitButtonText?.default?.['en-GB'],
      }
    });
  }
}
function* onFormSuccess(action) {
  const state = yield select();
  const selectFormFields = makeSelectFormFields(action.formId);
  const fields = selectFormFields(state);
  const redirect = fields.find(f => f.id === 'formSettingsRedirect');
  const message = fields.find(f => f.id === 'formSettingsMessage');
  if (redirect?.default) {
    window.location.href = redirect.default['en-GB'];
  }
  if (message?.default) {
    const m = message.default['en-GB'];
    if (m) {
      yield put({
        type: SET_SUCCESS_MESSAGE,
        message: m,
        formId: action.formId,
      }); 
    }
  }
}

function* onSubmitForm(action) {
  const { formId } = action || {};
  const state = yield select();
  const selectFormFieldErrors = makeSelectFormFieldErrors(formId)
  const errors = selectFormFieldErrors(state);

  const canSubmit = errors?.length === 0;
  if (canSubmit) {
    yield put({
      type: SET_SUBMITTING_FORM,
      isSubmitting: true,
      formId: action.formId,
    });
    const forms = yield select(selectForms);
    const rawData = forms[action.formId];
    const formObj = {
      contentType: action.formId,
      formPost: rawData.data,
    };
    const formResObj = yield postForm(formObj);
    if (formResObj?.sys?.id) {
      yield put({
        type: SUBMIT_FORM_SUCCESS,
        formId: action.formId,
      });
    } else {
      yield put({
        type: SUBMIT_FORM_ERROR,
        formId: action.formId,
      });
    }
  }
}

function* setDefaultValueFields(action) {
  const { formId, fields, defaultLanguage } = action;
  const entryId = yield select(selectors.selectRouteEntryEntryId);
  let fieldObj = {};
  fields.forEach(field => {
    if (field.dataType == 'string' && field.default) {
      const val = field.default[defaultLanguage];
      if (val) {
        fieldObj[field.id] = val;
      }
    }
    if (field.id == 'sourceEntry') {
      const val = entryId;
      if (val) {
        fieldObj[field.id] = val;
      }
    }
  });
  yield put({
    type: SET_DEFAULT_FIELD_VALUE,
    formId: formId,
    value: fieldObj,
  });
}
function* getEntryPickerData(action) {
  const { formId, fields } = action;
  const entriesToGet = fields.filter(f => f.dataFormat == 'entry');
  let entriesList = [];
  if (entriesToGet) {
    entriesList = yield all(
      entriesToGet.map(entry => {
        const entriesObj = {
          contentType: entry.validations.allowedContentTypes.contentTypes,
          versionStatus: 'published',
          language: 'en-GB',
          pageSize: '10',
        };
        return call(getEntries, entriesObj, entry.id);
      })
    );
    yield put({
      type: SET_FORM_ENTRIES,
      formId: formId,
      entries: entriesList,
    });
  }
}
